import React from "react";

function SpecialSection() {
  return (
    <div id="features" class="basic-2">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h2>Special Features</h2>
            <p class="p-heading">
              Sync's features are designed to help you improve your time
              management skills and become a better organized person. Organize
              your tasks, schedule your appointments and meet your personal
              development goals with Sync
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4">
            <ul class="list-unstyled li-space-lg first">
              <li class="media">
                <span class="fa-stack">
                  <i class="fas fa-circle fa-stack-2x"></i>
                  <i class="fas fa-users fa-stack-1x"></i>
                </span>
                <div class="media-body">
                  <h4>Social Interaction</h4>
                  <p>
                    Like any self improving process, everything starts with
                    setting your goals and committing to them
                  </p>
                </div>
              </li>
              <li class="media">
                <span class="fa-stack">
                  <i class="fas fa-circle fa-stack-2x green"></i>
                  <i class="fas fa-code fa-stack-1x"></i>
                </span>
                <div class="media-body">
                  <h4>Match Algorithm</h4>
                  <p>
                    Sync provides a well designed and ergonomic visual editor
                    for you to edit your quick notes
                  </p>
                </div>
              </li>
              <li class="media">
                <span class="fa-stack">
                  <i class="fas fa-circle fa-stack-2x red"></i>
                  <i class="fas fa-cog fa-stack-1x"></i>
                </span>
                <div class="media-body">
                  <h4>Tasks Settings</h4>
                  <p>
                    Each option packaged in the app's menus is provided in order
                    to improve you personally
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div class="col-lg-4">
            <img
              class="img-fluid"
              src="images/screen-7.png"
              alt="alternative"
            />
          </div>
          <div class="col-lg-4">
            <ul class="list-unstyled li-space-lg">
              <li class="media">
                <span class="fa-stack">
                  <i class="fas fa-circle fa-stack-2x yellow"></i>
                  <i class="fas fa-comments fa-stack-1x"></i>
                </span>
                <div class="media-body">
                  <h4>1v1 Messaging</h4>
                  <p>
                    Schedule your appointments, meetings and periodical
                    evaluations using the tools
                  </p>
                </div>
              </li>
              <li class="media">
                <span class="fa-stack">
                  <i class="fas fa-circle fa-stack-2x blue"></i>
                  <i class="fas fa-rocket fa-stack-1x"></i>
                </span>
                <div class="media-body">
                  <h4>24/7 Support</h4>
                  <p>
                    Reading focus mode for long form articles, ebooks and other
                    materials with long text
                  </p>
                </div>
              </li>
              <li class="media">
                <span class="fa-stack">
                  <i class="fas fa-circle fa-stack-2x"></i>
                  <i class="fas fa-star fa-stack-1x"></i>
                </span>
                <div class="media-body">
                  <h4>Good Reviews</h4>
                  <p>
                    Get a solid foundation for your self development efforts.
                    Try Sync mobile app for devices
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SpecialSection;
